export const PRODUCTPRICETYPE_DELETE_RESET = 'PRODUCTPRICETYPE_DELETE_RESET'
export const PRODUCTPRICETYPE_DELETE_SET_ERROR = 'PRODUCTPRICETYPE_DELETE_SET_ERROR'
export const PRODUCTPRICETYPE_DELETE_SET_DELETED = 'PRODUCTPRICETYPE_DELETE_SET_DELETED'
export const PRODUCTPRICETYPE_DELETE_TOGGLE_LOADING = 'PRODUCTPRICETYPE_DELETE_TOGGLE_LOADING'
